import usersService from './usersService'

export default usersService



// WEBPACK FOOTER //
// ../src/services/usersService/index.js